import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cbr_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);

export const fetchConfig = () => api.get("/config").then((r) => r.data);

export const createLead = (payload) =>
  api.post("/leads", payload).then((r) => r.data);

export const fetchAvailability = () =>
  api.get("/appointments/availability").then((r) => r.data);

export const bookAppointment = (payload) =>
  api.post("/appointments/book", payload).then((r) => r.data);

export const requestCallback = (leadId) =>
  api.post(`/leads/${leadId}/request-callback`).then((r) => r.data);

export const adminListLeads = () => api.get("/admin/leads").then((r) => r.data);
export const adminUpdateLead = (id, payload) =>
  api.patch(`/admin/leads/${id}`, payload).then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminNotifications = () =>
  api.get("/admin/notifications").then((r) => r.data);
